import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.07, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/shop/${product.id}`} className="group block">
        <div className="relative overflow-hidden bg-[#F7F5F0] aspect-[4/3]">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full p-4 object-contain transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
          {product.featured && (
            <div className="absolute top-3 left-3 label-eyebrow bg-white px-2 py-1">Featured</div>
          )}
          <div className="absolute bottom-3 right-3 bg-white px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="label-eyebrow">View →</span>
          </div>
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-lg md:text-xl tracking-tight">{product.name}</h3>
            <p className="label-eyebrow text-black/50 mt-1">{product.category}</p>
          </div>
          <div className="font-display text-lg md:text-xl">{`₹${product.price.toFixed(0)}`}</div>
        </div>
      </Link>
    </motion.div>
  );
}
